import { CloseOutlined } from '@ant-design/icons';
import type { Agent } from '../lib/api';
import AgentDetailView from './AgentDetailView';
import styles from './AgentDetailPanel.module.css';

/** Right-side detail panel for an Agent opened from a personal surface. */
export default function AgentDetailPanel({
  agent,
  onClose,
}: {
  agent: Agent;
  onClose: () => void;
}) {
  return (
    <div className={styles.root}>
      <button
        type="button"
        className={styles.close}
        aria-label="Close Agent panel"
        onClick={onClose}
      >
        <CloseOutlined />
      </button>
      <AgentDetailView agentId={agent.id} agent={agent} />
    </div>
  );
}
